<div class="main-point-cloud">
  <h3-scene-canvas
    [viewRegionNames]="viewRegionNames$ | async"
    [size]="size$ | async"
    [useTransparentBackground]="false"
  ></h3-scene-canvas>

  <div
    class="sections"
    [style.--toolbar-height]="toolbarHeight + 'px'"
    [class.with-top-toolbar]="
      (isNewEditPanel && (hasBottomEditPanels$ | async) === false) ||
      (hideRescaleAllToggle$ | async) !== true
    "
    [class.bottom-side-panels]="hasBottomEditPanels$ | async"
    [class.edit-panel-minimized]="isEditPanelMinimized$ | async"
    [class.replace-main-with-side-view-z]="
      (topViewHiddenInSplitView$ | async) === false
    "
  >
    <h3-main-view
      #mainView
      class="main-view"
      [class.bottom-side-panels]="
        (sideViewsHidden$ | async) === false && (hasBottomEditPanels$ | async)
      "
    ></h3-main-view>
    @if ((sideViewsHidden$ | async) === false) {
      <h3-edit-panel-toolbar
        [isSingleFrameTask]="isSingleFrameTask"
      ></h3-edit-panel-toolbar>
    }

    @if (isNewEditPanel) {
      <h3-edit-panel
        *ngIf="(topViewHidden$ | async) === false"
        class="side-view-z"
        [class.collapsed]="sideViewsHidden$ | async"
        [class.split-view]="hasBottomEditPanels$ | async"
        [axis]="2"
      ></h3-edit-panel>
      <h3-edit-panel
        class="side-view-y"
        [class.collapsed]="
          (sideViewsHidden$ | async) || (isEditPanelMinimized$ | async)
        "
        [axis]="1"
      ></h3-edit-panel>
      <h3-edit-panel
        class="side-view-x"
        [class.collapsed]="
          (sideViewsHidden$ | async) || (isEditPanelMinimized$ | async)
        "
        [axis]="0"
      ></h3-edit-panel>
    } @else {
      <h3-side-view
        *ngIf="(topViewHidden$ | async) === false"
        class="side-view-z"
        [class.collapsed]="sideViewsHidden$ | async"
        [class.split-view]="hasBottomEditPanels$ | async"
        [axis]="2"
      ></h3-side-view>
      <h3-side-view
        class="side-view-y"
        [class.collapsed]="
          (sideViewsHidden$ | async) || (isEditPanelMinimized$ | async)
        "
        [axis]="1"
      ></h3-side-view>
      <h3-side-view
        class="side-view-x"
        [class.collapsed]="
          (sideViewsHidden$ | async) || (isEditPanelMinimized$ | async)
        "
        [axis]="0"
      ></h3-side-view>
    }
  </div>
</div>
